module.exports = "/ui/b7f315e3b0ae9b39e6c166f092009d4e.png";